import { render } from "./Message.vue?vue&type=template&id=65e18263&scoped=true"
import script from "./Message.vue?vue&type=script&lang=js"
export * from "./Message.vue?vue&type=script&lang=js"

import "./Message.vue?vue&type=style&index=0&id=65e18263&scoped=true&lang=css"

import exportComponent from "/Users/Learning/Resource/workspace/vscode/HTML/jiang/anniversary/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-65e18263"]])

export default __exports__